/* eslint-disable react/destructuring-assignment */
import React, { useId } from 'react';
import BaseCollapsible from 'react-collapsible';
import PropTypes from 'prop-types';

function Collapsible({ triggerElementProps = {}, ...props }) {
  const id = useId();

  return (
    <BaseCollapsible
      {...props}
      contentElementId={`collapsible-content-${id}`}
      triggerElementProps={{
        ...triggerElementProps,
        id: `collapsible-trigger-${id}`,
      }}
    />
  );
}

Collapsible.propTypes = {
  triggerElementProps: PropTypes.shape({}),
};

export default Collapsible;
